/**
 * @fileOverview
 * Javascript to control the facets bar
 */

var scrolling = false;

/**
 * View object for facet functionality...all static methods
 */
window.facetsView = {
    /**
     * Expand a facet section
     * @param {string} elem Selector string for facet element
     * @param {object} e Event object
     */
    expandSection: function (elem, e) {
        if (e) {
            e.stopImmediatePropagation();
            e.preventDefault();
        }

        var filter = $(elem).find('.js-show-toggle').data('filter');

        $(elem)
            .find('.js-show-toggle')
            .removeClass('js-unexpanded')
            .addClass('js-expanded')
            .find('i')
            .addClass('icon-down-arrow')
            .removeClass('icon-forward-arrow');
        $(elem).attr('aria-expanded', 'true');
        $('[data-filter-content="' + filter + '"]').show();
    },

    /**
     * Collapse a facet section
     * @param {string} elem Selector string for facet element
     * @param {object} e Event object
     */
    collapseSection: function (elem, e) {
        if (e) {
            e.stopImmediatePropagation();
            e.preventDefault();
        }

        var filter = $(elem).find('.js-show-toggle').data('filter');

        $(elem)
            .find('.js-show-toggle')
            .removeClass('js-expanded')
            .addClass('js-unexpanded')
            .find('i')
            .addClass('icon-forward-arrow')
            .removeClass('icon-down-arrow');
        $(elem).attr('aria-expanded', 'false');
        $('[data-filter-content="' + filter + '"]').hide();
    },

    /**
     * Show more facets
     * @param {string} elem Selector string for facet element
     * @param {object} e Event object
     */
    showMore: function (elem, e) {
        var reveal = $(elem).data('more');
        $(elem)
            .siblings('ol')
            .children("li:not('.js-show-more'):last")
            .children('a')
            .focus();
        $('.js-show-more[data-more="' + reveal + '"]').show();
        $(elem).html(window.html('facets.less'));
        $(elem).removeClass('js-revealMore');
        $(elem).addClass('js-revealLess');
        $(elem).blur();
        $(elem).attr(
            'aria-label',
            window.html('facets.showFewerSubjectsLabel')
        );
        e.stopPropagation();
        e.preventDefault();
    },

    /**
     * Show less facets
     * @param {string} elem Selector string for facet element
     * @param {object} e Event object
     */
    showLess: function (elem, e) {
        var reveal = $(elem).data('more');
        $(elem)
            .siblings('ol')
            .children("li:not('.js-show-more'):last")
            .children('a')
            .focus();
        $('.js-show-more[data-more="' + reveal + '"]').hide();
        $(elem).html(window.html('facets.more'));
        $(elem).removeClass('js-revealLess');
        $(elem).addClass('js-revealMore');
        $(elem).attr('aria-label', window.html('facets.showMoreSubjectsLabel'));
        e.stopPropagation();
        e.preventDefault();
    },

    switchView: function (target) {
        if (!$('.' + target).hasClass('disabled')) {
            var container = $('.media-container.loaded');

            var classRemove =
                'large-block-grid-4 medium-block-grid-4 small-block-grid-2 list-view-ul';
            var classAdd =
                target == 'icon-list'
                    ? 'list-view-ul'
                    : 'large-block-grid-4 medium-block-grid-4 small-block-grid-2';

            var classRemove2 = 'grid-view list-view';
            var classAdd2 = target == 'icon-list' ? 'list-view' : 'grid-view';

            async.series([
                function (callback) {
                    //Hide the container to prevent display issues
                    container.hide();
                    callback(null);
                },
                function (callback) {
                    //Toggle classes
                    container
                        .children('ul:first-child')
                        .removeClass(classRemove)
                        .addClass(classAdd);
                    container.removeClass(classRemove2).addClass(classAdd2);

                    if (target == 'icon-list') {
                        $('i.icon-list').removeClass('light-gray');
                        $('i.icon-grid').addClass('light-gray');
                        window.facetsView.setViewCookie(target);
                    } else if (target == 'icon-grid') {
                        $('i.icon-list').addClass('light-gray');
                        $('i.icon-grid').removeClass('light-gray');
                        window.facetsView.setViewCookie(target);
                    }

                    callback(null);
                },
                function (callback) {
                    //Show the container
                    container.show();
                    callback(null);
                },
                function (callback) {
                    callback(null);
                },
            ]);
        }
    },

    setViewCookie: function (target) {
        if (target === 'icon-list') {
            Cookies.set('media-view-preference', 'list', {
                httpOnly: false,
                expires: 365,
                sameSite: 'lax',
                secure: true,
            });
        } else if (target === 'icon-grid') {
            Cookies.set('media-view-preference', 'grid', {
                httpOnly: false,
                expires: 365,
                sameSite: 'lax',
                secure: true,
            });
        }
    },
};

/*********** START JQUERY EVENT HANDLERS ************/

$(document).ready(function () {
    /* Select a facet */
    $('[data-facet]:not(.js-room-select)').on('click', function () {
        window.facetsController.select(this);
    });

    /* Restore a room facet */
    $('.js-room-select').on('click', function () {
        window.facetsController.restoreRoomFilter(
            $(this).data('facet-full-name')
        );
    });

    /* Remove all facets */
    $('.js-clear-all').on('click', function () {
        window.facetsController.removeAll();
    });

    /* Remove a facet */
    $('.js-filter-tag:not(.js-locked-filter)').on('click', function () {
        window.facetsController.remove(this);
    });

    /* Expand / Collapse facets */
    $('.js-expand-facet')
        .on('click tap', function (e) {
            if ($(this).attr('aria-expanded') === 'false') {
                window.facetsView.expandSection(this, e);
                $(this).attr('aria-expanded', true);
            } else {
                window.facetsView.collapseSection(this, e);
                $(this).attr('aria-expanded', false);
            }
        })
        .on('keydown', function (e) {
            if (e.key === ' ' || e.key === 'Enter') {
                e.preventDefault();
                if ($(this).attr('aria-expanded') === 'false') {
                    window.facetsView.expandSection(this, e);
                    $(this).attr('aria-expanded', true);
                } else {
                    window.facetsView.collapseSection(this, e);
                    $(this).attr('aria-expanded', false);
                }
            }
        });

    /* Toggle more/less facets button */
    $('[data-filter-content]')
        .on('click', '.js-revealMore', function (e) {
            window.facetsView.showMore(this, e);
        })
        .on('keydown', '.js-revealMore', function (e) {
            if (e.key === ' ' || e.key === 'Enter') {
                e.preventDefault();
                window.facetsView.showMore(this, e);
            }
        })
        .on('click', '.js-revealLess', function (e) {
            window.facetsView.showLess(this, e);
        })
        .on('keydown', '.js-revealLess', function (e) {
            if (e.key === ' ' || e.key === 'Enter') {
                e.preventDefault();
                window.facetsView.showLess(this, e);
            }
        });

    $('.js-showFacets').on('click', function () {
        if ($('.js-facetsContainer').css('display') === 'none') {
            $('.js-facetsContainer').css('display', 'block');
            $('.js-showFacets').addClass('is-expanded');
        } else {
            $('.js-facetsContainer').css('display', 'none');
            $('.js-showFacets').removeClass('is-expanded');
        }
    });

    $('.js-facetsContainer')
        .on('keydown', '*', function (e) {
            arrowTab(e);
        })
        .on('keydown', function (e) {
            arrowTab(e);
        });

    $('.js-remove-room-filter').on('click', function () {
        window.facetsController.removeRoomFilter($(this));
    });

    /*********** END JQUERY EVENT HANDLERS ************/

    if (bowser.mobile || bowser.tablet) {
        $('.js-showFacets').addClass('no-mobile-hover');
    }

    // Add blank spaces to empty divs for more responsive pages on old Android
    if (bowser.android && parseInt(bowser.osversion, 10) < 4) {
        $('div:empty').append('&nbsp;');
        // Re-render select and parent element to attempt to update displayed value
        $('.js-searchSortByOptions').on('change', function () {
            $(this).parent().hide();
            setTimeout(function () {
                $(this).parent().show();
            }, 0);
        });
    }
});

/**
 * Bind up and down keys to tab and shift-tab for facet navigation with arrow keys.
 * @param {object} e Event object
 */
function arrowTab(e) {
    switch (e.key) {
        case 'ArrowDown':
            e.preventDefault();
            $(e.target).emulateTab();
            break;

        case 'ArrowUp':
            e.preventDefault();
            $(e.target).emulateTab(-1);
            break;

        case 'ArrowRight':
            //Right arrow key pressed
            e.preventDefault();

            if (
                $(e.target).is('[aria-expanded]') &&
                $(e.target).attr('aria-expanded') == 'false'
            ) {
                window.facetsView.expandSection($(e.target), e);
            }
            break;

        case 'ArrowLeft':
            //Left arrow key pressed
            e.preventDefault();
            if (
                $(e.target).is('[aria-expanded]') &&
                $(e.target).attr('aria-expanded') == 'true'
            ) {
                window.facetsView.collapseSection($(e.target), e);
            }
            break;
    }

    e.stopPropagation();
}

/**
 * Get query parameters
 * @param {array} arr Array of parameters
 * @returns {string} Query parameter string
 */
function getParams(arr) {
    var params = [];

    for (i = 0; i < arr.length; ++i) {
        params.push('bucket=' + arr[i]);
    }

    return params.join('&');
}

//Dynamic read more description link based on overflow
$('.title-description').each(function () {
    if (
        $(this)[0].offsetHeight < $(this)[0].scrollHeight ||
        $(this)[0].offsetWidth < $(this)[0].scrollWidth
    ) {
        $(this).addClass('overflow');
    }
});

$(document).ready(function () {
    // Show clear all button if query parameters are present
    function toggleClearAll() {
        if (window.facetsController.countFacets() > 0) {
            $('.js-clear-all').show();
            $('.js-applied-filters').show();
        }
    }

    toggleClearAll();
});
